import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2929c0d2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container-sm inner" };
const _hoisted_2 = {
    key: 0,
    class: "main_text_block__header"
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
    key: 2,
    class: "is-mobile"
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = ["innerHTML"];
import { ref, onMounted } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'main_text_block',
    props: ['d'],
    setup(__props) {
        const props = __props;
        function addNoMarginClass() {
            const paragraphs = document.querySelectorAll('.main_text_block__content p');
            // Find the index of the last paragraph containing an anchor link
            let lastAnchorParagraphIndex = -1;
            for (let i = paragraphs.length - 1; i >= 0; i--) {
                const children = paragraphs[i].children;
                if (children.length === 1 && children[0].tagName.toLowerCase() === 'a') {
                    lastAnchorParagraphIndex = i;
                    break;
                }
            }
            // Add the no-margin class to paragraphs containing only an <a> tag except the last one
            for (let i = 0; i < paragraphs.length; i++) {
                const children = paragraphs[i].children;
                if (children.length === 1 && children[0].tagName.toLowerCase() === 'a' && i !== lastAnchorParagraphIndex) {
                    paragraphs[i].classList.add('no-margin');
                }
            }
        }
        const ctaBanner = ref(null);
        const isScrolledIntoView = ref(false);
        // Check if the device is mobile based on screen width
        const isMobile = ref(window.innerWidth <= 992);
        // Update isMobile value when the window size changes
        window.addEventListener('resize', () => {
            isMobile.value = window.innerWidth <= 992;
        });
        // Intersection Observer setup
        onMounted(() => {
            const options = {
                root: null,
                rootMargin: '0px',
                threshold: 0.5 // 0.5 means when 50% of the element is visible
            };
            const callback = (entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        isScrolledIntoView.value = true;
                        observer.unobserve(entry.target);
                    }
                });
            };
            const observer = new IntersectionObserver(callback, options);
            observer.observe(ctaBanner.value);
            addNoMarginClass();
        });
        return (_ctx, _cache) => {
            const _component_arrow = _resolveComponent("arrow");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["main_text_block", { 'scrolled': isScrolledIntoView.value }]),
                ref_key: "ctaBanner",
                ref: ctaBanner,
                style: _normalizeStyle(`background-color: ${__props.d.background_colour ? __props.d.background_colour : '#fff'}`)
            }, [
                _createElementVNode("div", _hoisted_1, [
                    (__props.d.line_one || __props.d.line_two)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            (__props.d.line_one && !isMobile.value)
                                ? (_openBlock(), _createElementBlock("h1", {
                                    key: 0,
                                    class: "line-one",
                                    innerHTML: __props.d.line_one
                                }, null, 8, _hoisted_3))
                                : _createCommentVNode("", true),
                            (__props.d.line_two && !isMobile.value)
                                ? (_openBlock(), _createElementBlock("h1", {
                                    key: 1,
                                    class: "line-two",
                                    innerHTML: __props.d.line_two
                                }, null, 8, _hoisted_4))
                                : _createCommentVNode("", true),
                            (isMobile.value)
                                ? (_openBlock(), _createElementBlock("h1", _hoisted_5, [
                                    _createElementVNode("span", {
                                        class: "line-one",
                                        innerHTML: __props.d.line_one
                                    }, null, 8, _hoisted_6),
                                    _createTextVNode(" "),
                                    _createElementVNode("span", {
                                        class: "line-two",
                                        innerHTML: __props.d.line_two
                                    }, null, 8, _hoisted_7)
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true),
                    (__props.d.leadin)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "main_text_block__content",
                            innerHTML: __props.d.leadin
                        }, null, 8, _hoisted_8))
                        : _createCommentVNode("", true),
                    (__props.d.show_arrow === 'true' || !__props.d.show_arrow)
                        ? (_openBlock(), _createBlock(_component_arrow, { key: 2 }))
                        : _createCommentVNode("", true)
                ])
            ], 6));
        };
    }
});
